// extracted by mini-css-extract-plugin
export default {"root":"WindowHint_root__O671K"};